import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

import arrow_left from '../../img/arrow_left.svg';
import arrow_right from '../../img/arrow_right.svg';

import SliderItem from '../SliderItem';
import './style.scss';

const GiftSlider = props => {
	const [slideIndex, setSlideIndex] = useState( 0 );

	const modalIsOpen = useSelector( store => store.modalIsOpen );

	const [slide, setSlide] = useState( null );

	useEffect( () => {
		if ( !!slide ) {
			if ( modalIsOpen ) {
				slide.slickPause();
			} else {
				slide.slickPlay();
			}
		}
	}, [modalIsOpen, slide] );

	const settings = {
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		// autoplay: false,
		// variableWidth: props.width <= 700,
		swipeToSlide: !props.width <= 600,
		centerPadding: props.width >= 540 ? '160px' : props.width >= 480 ? '140px' : props.width >= 440 ? '120px' : props.width >= 420 ? '110px' : props.width >= 400 ? '100px' : props.width >= 360 ? '80px' : props.width >= 320 && props.width < 360
			? '60px' : props.width <= 320 ? '55px' : '10px' ,
		// padding: "100px",
		speed: 600,
		centerMode: props.width < 600,
		draggable: true,
		mobileFirst: props.width <= 600,
		slidesToShow:
			props.width >= 600 ? ( props.bloggerData.gifts.length === 1 ? 1 : 2 ) : 1,
		slidesToScroll: props.width <= 600 ? 1 : 1,
		afterChange: current => setSlideIndex( current ),
	};
	const nextSlide = () => {
		slide.slickNext();
	};

	const prevSlide = () => {
		slide.slickPrev();
	};

	return (
		<div>
			{/*<div className="gift_slider_counter">*/ }
			{/*	{ slideIndex + 1 }/{ props.bloggerData.gifts.length }*/ }
			{/*</div>*/ }
			<div className="gift_slider" style={ props.width <= 600 ? { padding: '0', height: '260px' } : {} }>
				{ props.width >= 600 && <div className="gift_slider_nav">
					<img src={ arrow_left } alt="" onClick={ prevSlide }/>
				</div> }
				<div className={ props.width >= 600 ? 'gift_slider_slider'
					: `gift_slider_slider_mobile ${ props.width <= 600 && 'responsive_slider' }` }>
					<Slider ref={ c => setSlide( c ) } { ...settings }>
						{ props.bloggerData.gifts.map( (item, index) => <SliderItem key={ index }
						                                                            currentSlide={ slideIndex }
						                                                            data={ item }
						                                                            slideIndex={ index }
						                                                            totalSlides={ props.bloggerData.gifts.length }
						                                                            width={ props.width }
						                                                            slide={ slide }
							/>
						) }
					</Slider>
				</div>

				{ props.width >= 600 && <div className="gift_slider_nav">
					<img src={ arrow_right } alt="" onClick={ nextSlide }/>
				</div> }
			</div>
		</div>
	);
};

export default GiftSlider;
